<template>
  <div v-if="show" class="modal-overlay" @click.self="fechar">
    <div class="modal-container">
      <div class="modal-header">
        <h2>Gerenciar Produtos - {{ empresa?.nome }}</h2>
        <button class="btn-close" @click="fechar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="modal-description">
          Selecione os produtos que esta empresa tem acesso:
        </p>

        <div v-if="carregando" class="loading">
          <div class="spinner"></div>
          <p>Carregando produtos...</p>
        </div>

        <div v-else-if="todosProdutos.length > 0" class="produtos-list">
          <label
            v-for="produto in todosProdutos"
            :key="produto.id"
            class="produto-item"
          >
            <input
              type="checkbox"
              :value="produto.id"
              v-model="produtosSelecionados"
            />
            <div class="produto-info">
              <span class="produto-nome">{{ produto.nome }}</span>
              <span v-if="produto.descricao" class="produto-descricao">{{ produto.descricao }}</span>
            </div>
          </label>
        </div>

        <div v-else class="empty-produtos">
          <p>Nenhum produto disponível</p>
        </div>
      </div>

      <div class="modal-footer">
        <div class="footer-info">
          <span>{{ produtosSelecionados.length }} produto(s) selecionado(s)</span>
        </div>
        <div class="footer-actions">
          <button class="btn-secondary" @click="fechar">Cancelar</button>
          <button class="btn-primary" @click="salvar" :disabled="salvando">
            <span v-if="!salvando">Salvar</span>
            <span v-else>Salvando...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: 'ModalProdutos',
  props: {
    show: Boolean,
    empresa: Object
  },
  data() {
    return {
      todosProdutos: [],
      produtosSelecionados: [],
      carregando: false,
      salvando: false
    };
  },
  watch: {
    show(val) {
      if (val && this.empresa) {
        this.carregarProdutos();
      }
    }
  },
  methods: {
    async carregarProdutos() {
      this.carregando = true;

      try {
        const response = await api.get('/empresa/produtos', {
          withCredentials: true
        });

        this.todosProdutos = response.data.map(p => ({
          id: p.id || p.Id,
          nome: p.nome || p.Nome,
          descricao: p.descricao || p.Descricao
        }));

        // Seleciona os produtos já vinculados
        if (this.empresa?.produtos) {
          this.produtosSelecionados = this.empresa.produtos.map(p => p.id || p.Id);
        }

        this.carregando = false;
      } catch (error) {
        this.carregando = false;
        console.error('Erro ao carregar produtos:', error);

        this.$swal({
          icon: 'error',
          title: 'Erro ao carregar produtos',
          text: 'Não foi possível carregar a lista de produtos.',
        });
      }
    },
    async salvar() {
      this.salvando = true;

      try {
        const request = {
          EmpresaId: this.empresa.id,
          ProdutoIds: this.produtosSelecionados
        };

        await api.put(`/empresa/${this.empresa.id}/produtos`, request, {
          withCredentials: true
        });

        this.$swal({
          icon: 'success',
          title: 'Produtos atualizados!',
          text: 'Os produtos da empresa foram atualizados com sucesso.',
          timer: 2000,
          showConfirmButton: false
        });

        this.salvando = false;
        this.$emit('salvo');
      } catch (error) {
        this.salvando = false;
        console.error('Erro ao salvar produtos:', error);

        this.$swal({
          icon: 'error',
          title: 'Erro ao salvar',
          text: error.response?.data?.message || error.response?.data?.Message || 'Ocorreu um erro ao atualizar os produtos.',
        });
      }
    },
    fechar() {
      if (!this.salvando) {
        this.produtosSelecionados = [];
        this.$emit('close');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-container {
  background: white;
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 2px solid #f3f4f6;

  h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #00235C;
  }
}

.btn-close {
  padding: 0.5rem;
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #00235C;
  }
}

.modal-body {
  padding: 2rem;
  overflow-y: auto;
  flex: 1;
}

.modal-description {
  font-size: 0.9375rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

.loading {
  text-align: center;
  padding: 3rem 0;

  .spinner {
    width: 40px;
    height: 40px;
    margin: 0 auto 1rem;
    border: 4px solid #e5e7eb;
    border-top-color: #00235C;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  p {
    color: #6b7280;
    font-size: 0.9375rem;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.produtos-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.produto-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: white;
    border-color: #00235C;
  }

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-top: 2px;
    flex-shrink: 0;
  }
}

.produto-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.produto-nome {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
}

.produto-descricao {
  font-size: 0.8125rem;
  color: #6b7280;
}

.empty-produtos {
  text-align: center;
  padding: 3rem 0;

  p {
    color: #9ca3af;
    font-size: 0.9375rem;
  }
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-top: 2px solid #f3f4f6;
}

.footer-info {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.footer-actions {
  display: flex;
  gap: 1rem;
}

.btn-secondary,
.btn-primary {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary {
  background: white;
  border: 2px solid #e5e7eb;
  color: #6b7280;

  &:hover {
    background: #f9fafb;
    border-color: #6b7280;
  }
}

.btn-primary {
  background: linear-gradient(135deg, #00235C 0%, #001a45 100%);
  border: none;
  color: white;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 35, 92, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
